let ctx = null;

export const chimeEnabled = () => localStorage.getItem('regen_breath_chime') !== 'off';
export const setChimeEnabled = (on) => localStorage.setItem('regen_breath_chime', on ? 'on' : 'off');

// Call from a tap so mobile browsers allow audio.
export const unlockChime = () => {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === 'suspended') ctx.resume();
  } catch { ctx = null; }
};

// Soft bell: two gentle sine partials with a slow fade.
export const playChime = (final = false) => {
  if (!ctx) return;
  const t0 = ctx.currentTime + 0.02;
  const notes = final ? [[660, 0], [528, 0.45]] : [[528, 0], [660, 0.35]];
  notes.forEach(([f, d]) => [[f, 0.07], [f * 2.01, 0.015]].forEach(([freq, vol]) => {
    const o = ctx.createOscillator(); const g = ctx.createGain();
    o.type = 'sine'; o.frequency.value = freq;
    g.gain.setValueAtTime(0, t0 + d);
    g.gain.linearRampToValueAtTime(vol, t0 + d + 0.03);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + d + 2.2);
    o.connect(g).connect(ctx.destination);
    o.start(t0 + d); o.stop(t0 + d + 2.3);
  }));
};
